var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoldcastMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 190,
    viewBox: "0 0 95 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.875 94.7001C82.875 48.9269 45.7732 11.8251 0 11.8251V-0.00488281C52.3068 -0.00488281 94.705 42.3933 94.705 94.7001C94.705 147.007 52.3068 189.405 0 189.405V177.575C45.7732 177.575 82.875 140.473 82.875 94.7001Z",
    fill: "#FF4C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.355 94.7001C47.355 68.5469 26.1532 47.3451 0 47.3451V35.5151C32.6868 35.5151 59.185 62.0134 59.185 94.7001C59.185 127.385 32.6882 153.895 0 153.895V142.065C26.1518 142.065 47.355 120.855 47.355 94.7001Z",
    fill: "#FF4C00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoldcastMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/goldcast-mark.672eb7b99c357c89768bc2a30c938cb2.svg";